/**
Project: Voice Panel (c)
Title: Reducers
Description: Combine all reducers of the application 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import { combineReducers } from "redux";
import appReducer from "./app-reducer";
import subscriberReducer from "./voice-admin/subscriber-reducer";
import generalReducer from "./voice-admin/general-reducer";
import voiceSetupReducer from "./voice-admin/voice-setup-reducer";
import routingReducer from "./voice-admin/routing-reducer";
import userReducer from "./voice-admin/user-reducer";
import serviceNumberReducer from "./voice-admin/service-number-reducer";
import domainSetupReducer from "./voice-admin/domain-setup-reducer";
import adminDepartmentReducer from "./voice-admin/admin-department-reducer";
import adminNumberTypeReducer from "./voice-admin/admin-number-types-reducer";
import adminCarrierReducer from "./voice-admin/admin-carriers-reducer";
import adminDeviceTypeReducer from "./voice-admin/admin-device-type-reducer";
import inventoryNumberReducer from "./voice-admin/inventory-reducer";
import numberOrderReducer from "./voice-admin/number-order-reducer";

const reducers = combineReducers({
  appSettings: appReducer,
  subscriberStore: subscriberReducer,
  generalStore: generalReducer,
  voiceSetupStore: voiceSetupReducer,
  routingStore: routingReducer,
  userStore: userReducer,
  serviceNumberStore: serviceNumberReducer,
  domainSetupStore: domainSetupReducer,
  adminDepartmentStore: adminDepartmentReducer,
  adminNumberTypeStore: adminNumberTypeReducer,
  adminCarrierStore: adminCarrierReducer,
  adminDeviceTypeStore: adminDeviceTypeReducer,
  inventoryNumberStore: inventoryNumberReducer,
  numberOrderStore: numberOrderReducer
});

export default reducers;
